import { Checkbox } from '@/components/ui/checkbox';
import { FormControl, FormDescription, FormItem, FormLabel } from '@/components/ui/form';

type Props = {
  title: string;
  description: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};

/** Checkbox row for the Preferences card. Render inside a `FormField`. */
const PreferenceCheckbox = ({ title, description, checked, onCheckedChange }: Props) => (
  <FormItem className="flex flex-row items-start gap-3">
    <FormControl>
      <Checkbox checked={checked} onCheckedChange={(state) => onCheckedChange(state === true)} />
    </FormControl>
    <div>
      <FormLabel className="text-sm leading-none">{title}</FormLabel>
      <FormDescription>{description}</FormDescription>
    </div>
  </FormItem>
);

export default PreferenceCheckbox;
